import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  roleType: [],
};

const RoleSlice = createSlice({
  name: "RoleManagement",
  initialState,
  reducers: {
    setRoleType(state, action) {
      state.roleType = action.payload;
    },
  },
});

export const { setRoleType } = RoleSlice.actions;

export default RoleSlice.reducer;
